export const buildNumber = '20260303.1';
export const version = '3.12.1';
export const latestCommit = '56ae1cdcf7df15a956b99db2f34b5808f6d212e8';
